/* eslint no-param-reassign: 0 */
/* eslint no-sequences: 0 */

import _ from 'lodash';

const Util = {
  /** Convert a float data type to a ratio.
   *
   * @params {number} x: The float number that will be converted to a fraction
   */
  floatToRatio(x) {
    const tolerance = 1.0E-6;
    let h1 = 1;
    let h2 = 0;
    let k1 = 0;
    let k2 = 1;
    let b = x;
    do {
      const a = Math.floor(b);
      let aux = h1;
      h1 = a * h1 + h2;
      h2 = aux;
      aux = k1;
      k1 = a * k1 + k2;
      k2 = aux;
      b = 1 / (b - a);
    } while (Math.abs(x - h1 / k1) > x * tolerance);

    return h1 + '/' + k1;
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  getRegion(params) {
    const itsParams = Util.getParams(params || window.location.search);
    if(itsParams.region) {
      return itsParams.region;
    } else if(window.s_user_origin) {
      return window.s_user_origin;
    } else {
    return null;
    }
  },
  queryParams(source) {
    const array = [];
    for (const key in source) {
      if ({}.hasOwnProperty.call(source, key)) {
        array.push(encodeURIComponent(key) + '=' + encodeURIComponent(source[key]));
      }
    }
    return array.join('&');
  },

  toArray(obj) {
    return (_.isArray(obj) ? obj : [obj]);
  },

  mixin(...args) {
    return _.extend.apply(null, args.map(_.clone));
  },

  forceRepaint(node) {
    node.style.display = 'none';
    Util.nextTick(() => node.style.display = '');
  },

  /* Returns true if the current device is mobile, else returns false */
  isMobile: function() {
    return /android|webos|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase());
  },

  isTouchDevice: function() {
    return 'ontouchstart' in window || 'onmsgesturechange' in window;
  },
  /**
   * Parse query params into an object
   */

  getParams(qs_) {
    return (qs_ || document.location.search).replace(/(^\?)/, '').split('&').map(function(n) {return n = n.split('='), this[n[0]] = n[1], this; }.bind({}))[0];
  },
  urlToJSONP: function(dataUrl) {
    let [url, query] = dataUrl.split('?'); /* eslint prefer-const:0 */
    if (query) {
      url += `?${query}&`;
    } else {
      url += '?';
    }
    url += 'callback=?';
    return url;
  },


  /**
   * Alternate Environment Checking Function, Handles all
   * combination of qa/staging/proddev and inserts a period, for
   * direct use in URLs */
  envCheck() {
    let env = '';
    if (window.location.href.indexOf('.staging.') !== -1) {
      if (window.location.href.match(/\.qa\d\d/) !== null) {
        env = '.staging' + window.location.href.match(/\.qa\d\d/)[0];
      } else {
        env = '.staging';
      }
    } else if (window.location.href.indexOf('.proddev.') !== -1) {
      env = '.proddev';
    } else if (window.location.href.match(/\.qa\d\d/) !== null) {
      env = env + window.location.href.match(/\.qa\d\d/)[0];
    }
    return env;
  },

  /**
   * returns the default image server for but also takes an override for when
   * you're testing locally but you want to override and point at a remote.
   */
  imageServer: function(env) {
    const sub = env ? env : Util.envCheck();
    const prodEnv = ['www.medscape.com', 'www.medscape.org', 'reference.medscape.com', 'education.webmd.com'];
    const isProd = prodEnv.some((envUrl) => {
      return (window.location.host.indexOf(envUrl) !== -1);
    });
    if (isProd) {
      return 'http://img.medscapestatic.com';
    }
    if (env === 'override') {
      return '';
    } else if (sub === '' && Util.isLocal()) {
      return 'http://img.qa01.medscapestatic.com';
    } else {
      return `http://img${sub}.medscapestatic.com`;
    }
  },
  getImageServer() {
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    }
    return window.location.origin.replace('www', 'img').replace('medscape', 'medscapestatic');
  },
  getJSONDataAttribute(name) {
    const dataElement = document.querySelector(`[data-${name}]`);
    if(dataElement !== null) {
      try {
          const data = dataElement.getAttribute(`data-${name}`);
          const json = JSON.parse(data);
          return json;
      } catch (e) {
        console.log('error');
        return {};
      }
    }
      return {};
  },
  isLocal: function() {
    return (document.location.hostname === 'localhost');
  },

  /** Returns true if the current device is Retina display */
  isRetina: function() {
    return (window.devicePixelRatio > 1);
  },

  /** Returns true if the current device is ipad */
  isIpad: function() {
    return navigator.userAgent.match(/iPad/i) !== null;
  },
  isIOS: function(version) {
    let isIOS = Util.isIpad() || navigator.userAgent.match(/iPhone/i);
    if (version) {
      isIOS = isIOS && navigator.userAgent.match(new RegExp('OS ' + version));
    }
    return isIOS;
  },
  isSafari: function() {
    return Util.isIOS() && (navigator.userAgent.indexOf('Safari') > -1);
  },
  isApp: function() {
    return !!navigator.userAgent.toLowerCase().match('medscape');
  },
  nextTick: function(f) {
    setTimeout(f, 0);
  },
  removeElementById(id) {
    const elem = document.getElementById(id);
    elem.parentNode.removeChild(elem);
  },
  getXhr(url) {
    const Promise = require('native-promise-only');
    return new Promise(function(resolve, reject) {
      const req = new XMLHttpRequest();
      req.open('GET', url);
      req.onload = function() {
        if (req.status === 200) {
          resolve(req.response);
        } else {
          reject(Error(req.statusText));
        }
      };
      req.onerror = function() {
        reject(Error('Network Error'));
      };
      req.send();
    });
  },
  isDescendant(parent, child) {
    let node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  },
  getOffset(element, target) {
    const offset = { top: element.offsetTop, left: element.offsetLeft };
    let parent = element.offsetParent;
    while (parent !== null && parent !== target) {
       offset.left += parent.offsetLeft;
       offset.top  += parent.offsetTop;
       parent = parent.offsetParent;
    }
    return offset;
  },
  setCookie(a, b, c) {
    let e = '';
    if (c) {
      const d = new Date;
      d.setTime(d.getTime() + c * 24 * 60 * 60 * 1e3);
      e = '; expires=' + d.toGMTString();
    }
    document.cookie = a + '=' + b + e + '; path=/';
  },
  deleteCookie(a) {
    Util.setCookie(a, '', -1);
  },
  getCookie(a) {
    const b = a + '=';
    const c = document.cookie.split(';');
    for (let d = 0; d < c.length; d++) {
      let e = c[d];
      while (e.charAt(0) === ' ') e = e.substring(1, e.length);
      if (e.indexOf(b) === 0) {
        return e.substring(b.length, e.length);
      }
    }
    return null;
  },
  isElementInViewport(el, offsetHeight) {
    if(el !== null) {
      const rect = el.getBoundingClientRect();

      return (
          rect.top + offsetHeight >= 0 &&
          rect.left >= 0 &&
          rect.bottom - offsetHeight <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  },
  isElementScrolled(el) {
    const top  = window.pageYOffset || document.documentElement.scrollTop,
        height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    if(el !== null) {
      const elTop = Util.getOffset(el, document).top;
      return (
          (elTop + 100) < (top + height)
      );
    }
  }
};

module.exports = Util;



/** WEBPACK FOOTER **
 ** ./modules/utils/util.js
 **/